import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import InvestPage from "./pages/InvestPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import WithdrawalProofsPage from "./pages/WithdrawalProofsPage";
import RegulationsPage from "./pages/RegulationsPage";
import TeamPage from "./pages/TeamPage";
import LegalPage from "./pages/LegalPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import ChatbotWidget from "./components/ChatbotWidget";
import SocialProofPopups from "./components/SocialProofPopups";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/invest" element={<InvestPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/withdrawal-proofs" element={<WithdrawalProofsPage />} />
            <Route path="/regulations" element={<RegulationsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/admin-duo-secure" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
          </Routes>
          <SocialProofPopups />
          <ChatbotWidget />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
